import {
    call,
    put,
    select,
    //takeEvery,
    takeLeading,
} from "redux-saga/effects";
import { AppState } from "../index";

import {
  handleSelectedOneDaySaleTradeIn,
    pendingGetOneDaySaleAppraisalById,
    pendingGetOneDaySaleDate,
    rejectedGetOneDaySaleAppraisalById,
    rejectedGetOneDaySaleDate,
    resolvedGetOneDaySaleDate,
    pendingGetOneDayAppraisalTable,
    resolvedGetOneDayAppraisalTable,
    rejectedGetOneDayAppraisalTable,
    pendingGetOneDaySaleWorkbook,
    rejectedGetOneDaySaleWorkbook,
    resolvedGetOneDaySaleWorkbook,
    resolvedOnedaySaleWarning,
} from "store/oneDaySale/oneDaySale.action";

import {
    addOneDaySaleDate,
    deleteOneDaySaleDateItem,
    getAppraisalVehicleDetails,
    getAppraisalVehicleVIN,
    getOneDaySaleDate,
    saveOneDaySaleAppraisal,
    saveOneDaySaleDateItem,
    getOneDaySaleNotes,
    saveOneDaySaleNotes,
   
    getOneDaySaleAppraisalbyId,
    addOneDaySaleAppraisal,
    updateOneDaySaleAppraisal,
    getOneDayAppraisalTable,
    addOneDayAppraisalTableItem,
    createOneDayAppraisalDealTradeIn,
    getOneDaySaleWorkbook,
    createOneDaySaleDealRecord,
    searchOneDaySaleDealRecord,
    createAppraisalFormvalues,
    addOneDaySaleToDealTradeIn,
    deleteOneDaySale

} from "store/oneDaySale/oneDaySale.api";

import {
    HANDLE_CREATE_ONE_DAY_SALE_DATE,
    HANDLE_DELETE_ONE_DAY_SALE_DATE,
    HANDLE_GET_APPRAISAL_TRIM_VIN,
    HANDLE_GET_APPRAISAL_VEH_DETAILS,
    HANDLE_GET_ONE_DAY_SALE_DATE,
    HANDLE_UPDATE_ONE_DAY_SALE_DATE,
    HandleCreateOneDaySaleDate,
    HandleGetAppraisalTrimUsingVin,
    HandleGetAppraisalVehDetails,
    HandleGetOneDaySaleDate,
    HandleUpdateOneDaySaleDate,
    HANDLE_GET_ONE_DAY_SALE_NOTES,
    HANDLE_SAVE_ONE_DAY_SALE_NOTES,
    HandleGetOneDaySaleNotes,
    HandleSaveOneDaySaleNotes,
   
    HandleGetOneDaySaleAppraisalById,
    HandleCreateOneDaySaleAppraisal,
    HandleUpdateOneDaySaleAppraisal,
  
    HANDLE_GET_ONE_DAY_SALE_APPRAISAL_BY_ID,
    HANDLE_UPDATE_ONE_DAY_SALE_APPRAISAL,
    HANDLE_CREATE_ONE_DAY_SALE_APPRAISAL,
    HANDLE_GET_ONE_DAY_APPRAISAL_TABLE_LIST,
    HandleGetOneDayAppraisalTable,
    HANDLE_CREATE_ONE_DAY_APPRAISAL_TABLE_LIST_ITEM,
    HandleCreateOneDayAppraisalTableItem,
    HandleGetOneDaySaleWorkbook,
    HANDLE_GET_ONE_DAY_SALE_WORKBOOK,
    HandleSearchOneDaySaleDealRecord,
    HandleCreateOneDaySaleDealRecord,
    HANDLE_SEARCH_ONE_DAY_SALE_DEAL_RECORD,
    HANDLE_CREATE_ONE_DAY_SALE_DEAL_RECORD,
    HANDLE_CREATE_APPRAISAL_FORM_VALUE,
    HandleCreateAppraisalFormValue,
    HandleShowOnedaySaleWarning,
    HANDLE_SHOW_ONEDAY_SALE_WARNING,
    HandleAddOneDaySaleToDealTradeIn,
    HANDLE_ADD_ONE_DAY_SALE_TO_DEAL_TRADEIN,
    HandleDeleteOneDaySale,
    HANDLE_DELETE_ONE_DAY_SALE

} from "store/oneDaySale/oneDaySale.types";

import { switchGlobalLoader } from "store/globalLoading/globalLoading.action";
import { handleGetVehDetailsSuccess } from "store/inventory/inventory.action";

export function* getOneDaySaleWorkbookSaga(actions: HandleGetOneDaySaleWorkbook) {
  yield put(switchGlobalLoader(true));
  const { formData,callback } = actions.payload;
  try {
      yield put(pendingGetOneDaySaleWorkbook());
      const { error, data } = yield getOneDaySaleWorkbook(formData);
      callback(data,null);
      if (error) {
          yield put(rejectedGetOneDaySaleWorkbook(error.violations as any));
          yield put(switchGlobalLoader(false));
          callback(null,error);
          return;
      }

      yield put(resolvedGetOneDaySaleWorkbook(data));
  }
  catch (error) {
      yield put(switchGlobalLoader(false));
      return;
  }
  yield put(switchGlobalLoader(false));
}

export function* getOneDaySaleAppraisalByIdSaga(actions: HandleGetOneDaySaleAppraisalById) {
  yield put(switchGlobalLoader(true));
  const { id, callback} = actions.payload;
  try {
      yield put(pendingGetOneDaySaleAppraisalById());
      const { error, data } = yield getOneDaySaleAppraisalbyId(id);
      if(data){
       
       yield put(handleSelectedOneDaySaleTradeIn(data));
       callback(data);
       yield put(switchGlobalLoader(false));
       // yield put(resolvedGetOneDaySaleAppraisalById(data));
        return;
      }
      if (error) {
          yield put(rejectedGetOneDaySaleAppraisalById(error.violations as any));
          yield put(switchGlobalLoader(false));
          return;
      }

    
  }
  catch (error) {
      yield put(switchGlobalLoader(false));
      return;
  }
  yield put(switchGlobalLoader(false));
}

//create one day appraisal--to remove

function* createOneDaySaleAppraisalSaga(action: HandleCreateOneDaySaleAppraisal) {
  yield put(switchGlobalLoader(true));
  try {
    const { saleDate, callback } = action.payload;
    const { result, error } = yield addOneDaySaleAppraisal(saleDate);
    if (result) {
      callback(result,null);
      return;
    }
    callback(null,error);
    yield put(switchGlobalLoader(false));
    return;
  } catch (error) {
      yield put(switchGlobalLoader(false));
    return;
  }
}

function* updateOneDaySaleAppraisalSaga(action: HandleUpdateOneDaySaleAppraisal) {
  yield put(switchGlobalLoader(true));
  try {
    const { id, data, callback } = action.payload;
    const { result, error } = yield updateOneDaySaleAppraisal(id,data);
    if (result) {
      callback(result,null);
      yield put(switchGlobalLoader(false));
      return;
    }
    callback(null,error);
    yield put(switchGlobalLoader(false));
    return;
  } catch (error) {
      yield put(switchGlobalLoader(false));
    return;
  }
}

export function* getOneDaySaleDateSaga(actions: HandleGetOneDaySaleDate) {
    yield put(switchGlobalLoader(true));
    const { formData } = actions.payload;
    try {
        yield put(pendingGetOneDaySaleDate());
        const { error, data } = yield getOneDaySaleDate(formData);
        if (error) {
            yield put(rejectedGetOneDaySaleDate(error.violations as any));
            yield put(switchGlobalLoader(false));
            return;
        }

        yield put(resolvedGetOneDaySaleDate(data));
    }
    catch (error) {
        yield put(switchGlobalLoader(false));
        return;
    }
    yield put(switchGlobalLoader(false));
}

function* createOneDaySaleDateSaga(action: HandleCreateOneDaySaleDate) {
    yield put(switchGlobalLoader(true));
    try {
      const { saleDate, callback } = action.payload;
      const { result, error } = yield addOneDaySaleDate(saleDate);
      if (result) {
        callback(result,null);
        return;
      }
      callback(null,error);
      yield put(switchGlobalLoader(false));
      return;
    } catch (error) {
        yield put(switchGlobalLoader(false));
      return;
    }
  }

  function* updateOneDaySaleDateSaga(action: HandleUpdateOneDaySaleDate) {
    yield put(switchGlobalLoader(true));
    try {
      const { id,saleDate, callback } = action.payload;
      const { result, error } = yield saveOneDaySaleDateItem(id,saleDate);
      if (result) {
        callback(result,null);
        return;
      }
      callback(null,error);
      yield put(switchGlobalLoader(false));
      return;
    } catch (error) {
        yield put(switchGlobalLoader(false));
      return;
    }
  }

  function* deleteOneDaySaleDateSaga(action: HandleUpdateOneDaySaleDate) {
    yield put(switchGlobalLoader(true));
    try {
      const { id, callback } = action.payload;
      const { result, error } = yield deleteOneDaySaleDateItem(id);
      if (result) {
        callback(result,null);
        return;
      }
      callback(null,error);
      yield put(switchGlobalLoader(false));
      return;
    } catch (error) {
        yield put(switchGlobalLoader(false));
      return;
    }
  }

  function* getAppraisalTrimVINSaga(action: HandleGetAppraisalTrimUsingVin) { 
    yield put(switchGlobalLoader(true));
  
      try {
         
      const { dataFilter, errorFilter } = yield getAppraisalVehicleVIN(action.payload.vin);
      if (dataFilter) {
    
        action.payload.callback(dataFilter);
      }
      action.payload.callback(errorFilter);
      yield put(switchGlobalLoader(false));
        return;
    } catch (error) {
      yield put(switchGlobalLoader(false));
    }
    yield put(switchGlobalLoader(false));
  
  }

  export function* getOneDayAppraisalTableSaga(action: HandleGetOneDayAppraisalTable) {
    yield put(switchGlobalLoader(true));
    try {
        yield put(pendingGetOneDayAppraisalTable());
        const { tradeInId, callback } = action.payload;

        const { error, data } = yield call(getOneDayAppraisalTable, { tradeInId });

        if (data) {
            yield put(resolvedGetOneDayAppraisalTable(data.results));
            if (callback) {
                callback(null, data.results);
            }
        } else if (error) {
            yield put(rejectedGetOneDayAppraisalTable(error.violations as any));
            if (callback) {
                callback(error, null);
            }
        }
    } catch (error) {
        yield put(rejectedGetOneDayAppraisalTable('Something went wrong.'));
        if (action.payload.callback) {
            action.payload.callback(error, null);
        }
    } finally {
        yield put(switchGlobalLoader(false));
    }
}


  function* getAppraisalVehDetailsSaga(action: HandleGetAppraisalVehDetails) {
  yield put(switchGlobalLoader(true));

  try {
          const selectedTradeInInfo = yield select((state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn);
          if ( !selectedTradeInInfo?.id) {
              const appraisalInfo = yield saveOneDaySaleAppraisal({});
              if (appraisalInfo && appraisalInfo.data) {
                  
                  const { dataFilter, errorFilter } = yield getAppraisalVehicleDetails(action.payload.vehDet,  appraisalInfo.data.id);
                  if (dataFilter) {
                      yield put(handleGetVehDetailsSuccess(dataFilter));
                      const tradeInDetail = {
                          id: appraisalInfo.data.id,
                          vehicle: dataFilter
                      }
                      yield put(handleSelectedOneDaySaleTradeIn(tradeInDetail));
                      action.payload.callback(dataFilter);
                  }
                  else if (errorFilter) {
                      yield put(handleSelectedOneDaySaleTradeIn(appraisalInfo.data));
                      action.payload.callback(false);
                  }
                  yield put(switchGlobalLoader(false));
                  return;
              }
          } else {
              const { dataFilter, errorFilter } = yield getAppraisalVehicleDetails(action.payload.vehDet, selectedTradeInInfo.id);
              if (dataFilter) {
                  yield put(handleGetVehDetailsSuccess(dataFilter));

                 let data = {...selectedTradeInInfo}
                 data['vehicle'] = dataFilter
                  yield put(handleSelectedOneDaySaleTradeIn(data));
                  action.payload.callback(dataFilter);
              }
              else if (errorFilter) {
                  action.payload.callback(false);
              }
          }
      yield put(switchGlobalLoader(false));
      return;
     
  } catch (error) {
      yield put(switchGlobalLoader(false));
      return;
  }
}

function* getOneDaySaleNotesSaga(action: HandleGetOneDaySaleNotes) {
  yield put(switchGlobalLoader(true));
  try {
    const { data, error } = yield getOneDaySaleNotes(
      action.payload.dealTradeInId
    );
    if (data) {
      action.payload.callback(data);
    }
    if (error) {
      action.payload.callback(false);
      yield put(switchGlobalLoader(false));
      return;
    }
    yield put(switchGlobalLoader(false));
    return;
  } catch (error) {
    yield put(switchGlobalLoader(false));
  }
  yield put(switchGlobalLoader(false));
}

function* saveOneDaySaleNotesSaga(action: HandleSaveOneDaySaleNotes) {
  yield put(switchGlobalLoader(true));

  try {
          const selectedTradeInInfo = yield select((state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn);
          if ( !selectedTradeInInfo?.id) {
              const appraisalInfo = yield saveOneDaySaleAppraisal({});
              if (appraisalInfo && appraisalInfo.data) {
                  
                  const { data, error  } = yield saveOneDaySaleNotes(action.payload.details,  appraisalInfo.data.id);
                  if (data) {
                      const tradeInDetail = {
                          id: appraisalInfo.data.id,
                      }
                      yield put(handleSelectedOneDaySaleTradeIn(tradeInDetail));
                      action.payload.callback(data);
                  }
                  else if (error) {
                      yield put(handleSelectedOneDaySaleTradeIn(appraisalInfo.data));
                      action.payload.callback(false);
                  }
                  yield put(switchGlobalLoader(false));
                  return;
              }
          } else {
              const { data, error  } = yield saveOneDaySaleNotes(action.payload.details, selectedTradeInInfo.id);
              if (data) {

                 let data = {...selectedTradeInInfo}
                  yield put(handleSelectedOneDaySaleTradeIn(data));
                  action.payload.callback(data);
              }
              else if (error) {
                  action.payload.callback(false);
              }
          }
      yield put(switchGlobalLoader(false));
      return;
     
  } catch (error) {
      yield put(switchGlobalLoader(false));
      return;
  }
}

function* createOneDayAppraisalTableSaga(action: HandleCreateOneDayAppraisalTableItem) {
    yield put(switchGlobalLoader(true));
    try {
        const { formData } = action.payload;
        const selectedTradeInInfo = yield select((state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn);

        if ( !selectedTradeInInfo?.id) {
            const appraisalInfo = yield createOneDayAppraisalDealTradeIn({});
            if (appraisalInfo && appraisalInfo.data) {
                const { result } = yield addOneDayAppraisalTableItem(appraisalInfo.data.id, formData);
                if (typeof action.payload.callback === "function") {
                    if (result) {
                        const { error, data } = yield getOneDayAppraisalTable({ tradeInId: appraisalInfo.data.id });
                        if (error) {
                            yield put(rejectedGetOneDayAppraisalTable(error.violations as any));
                        } else {
                            yield put(resolvedGetOneDayAppraisalTable(data.results));
                        }
                    }
                    action.payload.callback(appraisalInfo.data.id);
                    yield put(switchGlobalLoader(false));
                    return;
                }
            }
        } else {
            const { result } = yield addOneDayAppraisalTableItem(selectedTradeInInfo.id, formData);
            if (typeof action.payload.callback === "function") {
                if (result) {
                    const { error, data } = yield getOneDayAppraisalTable({ tradeInId: selectedTradeInInfo.id });
                    if (error) {
                        yield put(rejectedGetOneDayAppraisalTable(error.violations as any));
                    } else {
                        yield put(resolvedGetOneDayAppraisalTable(data.results));
                    }
                }
                action.payload.callback(selectedTradeInInfo.id);
                yield put(switchGlobalLoader(false));
                return;
            }
        }
        action.payload.callback(null);
        yield put(switchGlobalLoader(false));
    } catch (error) {
        yield put(switchGlobalLoader(false));
    }
}

function* searchDealRecordSaga(action: HandleSearchOneDaySaleDealRecord) {

    yield put(switchGlobalLoader(true));
    try {
        const { deal, callback } = action.payload;

        const selectedTradeInInfo = yield select((state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn);

        if ( !selectedTradeInInfo?.id) {
            const appraisalInfo = yield saveOneDaySaleAppraisal({});
            if (appraisalInfo && appraisalInfo.data) {
                const { data, error } = yield searchOneDaySaleDealRecord(appraisalInfo.data.id, deal);
                if (typeof action.payload.callback === "function") {
                    if (data) {
                        callback(data);
                    }
                   callback(error);
                    yield put(switchGlobalLoader(false));
                    return;
                }
            }
        } else {
            const { data, error } = yield searchOneDaySaleDealRecord(selectedTradeInInfo.id, deal);
            if (data) {
                callback(data);
                yield put(switchGlobalLoader(false));
                return;
            }
            callback(error);
            yield put(switchGlobalLoader(false));
            return;
           
        }
        yield put(switchGlobalLoader(false));


     
        return;
    } catch (error) {
        return;
    }
}


function* createDealRecordSaga(action: HandleCreateOneDaySaleDealRecord) {
    yield put(switchGlobalLoader(true));
    try {
        const { deal, callback } = action.payload;
        const selectedTradeInInfo = yield select((state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn);
        const { data, error } = yield createOneDaySaleDealRecord(selectedTradeInInfo.id,deal);
        if (data) {
            callback(data);
            yield put(switchGlobalLoader(false));
            return;
        }
        callback(error);
        // yield put(resolvedCreateDeal(data));
        yield put(switchGlobalLoader(false));
        return;
    } catch (error) {
        return;
    }
}

function* createAppraisalFormValueSaga(action: HandleCreateAppraisalFormValue) {
    yield put(switchGlobalLoader(true));
    const { formData, callback } = action.payload;
    try {
        const { data } = yield call(createAppraisalFormvalues, formData);
        if (data) {
            callback(data.id);
        } else {
            callback(null);
        }
    } catch (error) {
        return;
    }
    yield put(switchGlobalLoader(false));
}

function* showOnedaySaleWarningSaga(action: HandleShowOnedaySaleWarning) {
    const { formData } = action.payload;
    try {
        yield put(resolvedOnedaySaleWarning(formData));
    } catch (error) {
        return;
    }
}

function* addOneDaySaleToDealTradeInSaga(action: HandleAddOneDaySaleToDealTradeIn) {
    yield put(switchGlobalLoader(true));
    try {
        const { deal, callback } = action.payload;
        const selectedTradeInInfo = yield select((state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn);
        const { data, error } = yield addOneDaySaleToDealTradeIn(selectedTradeInInfo.id,deal);
        if (data) {
            callback(data);
            yield put(switchGlobalLoader(false));
            return;
        }
        callback(error);
        yield put(switchGlobalLoader(false));
        return;
    } catch (error) {
        return;
    }
}

  function* deleteOneDaySaleSaga(action: HandleDeleteOneDaySale) {
    yield put(switchGlobalLoader(true));
    try {
      const { id, callback } = action.payload;
      const { result, error } = yield deleteOneDaySale(id);
      if (result) {
        callback(result,null);
        return;
      }
      callback(null,error);
      yield put(switchGlobalLoader(false));
      return;
    } catch (error) {
        yield put(switchGlobalLoader(false));
      return;
    }
  }


export default function* OneDaySaleSaga() {
    yield takeLeading(HANDLE_GET_ONE_DAY_SALE_DATE, getOneDaySaleDateSaga);
    yield takeLeading(HANDLE_GET_ONE_DAY_SALE_WORKBOOK, getOneDaySaleWorkbookSaga);
    yield takeLeading(HANDLE_CREATE_ONE_DAY_SALE_DATE, createOneDaySaleDateSaga);
    yield takeLeading(HANDLE_UPDATE_ONE_DAY_SALE_DATE,updateOneDaySaleDateSaga );
    yield takeLeading(HANDLE_DELETE_ONE_DAY_SALE_DATE,deleteOneDaySaleDateSaga );
    yield takeLeading(HANDLE_GET_ONE_DAY_SALE_NOTES,getOneDaySaleNotesSaga );
    yield takeLeading(HANDLE_SAVE_ONE_DAY_SALE_NOTES,saveOneDaySaleNotesSaga );
    yield takeLeading(HANDLE_GET_APPRAISAL_VEH_DETAILS,getAppraisalVehDetailsSaga );
    yield takeLeading(HANDLE_GET_APPRAISAL_TRIM_VIN,getAppraisalTrimVINSaga );
  //  yield takeLeading(HANDLE_GET_ONE_DAY_SALE_APPRAISAL ,getOneDaySaleAppraisalSaga );
    yield takeLeading(HANDLE_GET_ONE_DAY_SALE_APPRAISAL_BY_ID ,getOneDaySaleAppraisalByIdSaga );
    yield takeLeading(HANDLE_CREATE_ONE_DAY_SALE_APPRAISAL ,createOneDaySaleAppraisalSaga );
    yield takeLeading(HANDLE_UPDATE_ONE_DAY_SALE_APPRAISAL,updateOneDaySaleAppraisalSaga );
    yield takeLeading(HANDLE_GET_ONE_DAY_APPRAISAL_TABLE_LIST, getOneDayAppraisalTableSaga);
    yield takeLeading(HANDLE_CREATE_ONE_DAY_APPRAISAL_TABLE_LIST_ITEM, createOneDayAppraisalTableSaga);
    yield takeLeading(HANDLE_SEARCH_ONE_DAY_SALE_DEAL_RECORD, searchDealRecordSaga);
    yield takeLeading(HANDLE_CREATE_ONE_DAY_SALE_DEAL_RECORD, createDealRecordSaga);
    yield takeLeading(HANDLE_CREATE_APPRAISAL_FORM_VALUE, createAppraisalFormValueSaga);
    yield takeLeading(HANDLE_SHOW_ONEDAY_SALE_WARNING, showOnedaySaleWarningSaga);
    yield takeLeading(HANDLE_ADD_ONE_DAY_SALE_TO_DEAL_TRADEIN, addOneDaySaleToDealTradeInSaga);
    yield takeLeading(HANDLE_DELETE_ONE_DAY_SALE, deleteOneDaySaleSaga);

}